import { GoogleMap, Marker, useJsApiLoader, Autocomplete, Circle } from '@react-google-maps/api';
import { Input } from 'antd';
import { useState, useCallback, useRef, Fragment } from 'react';
import PointerMap from '../../assets/map/mapPointer.png';
import { t } from '../../i18n/i18n';
import './MapComponent.scss';

const inputStyle = {
  width: '75hv',
  height: '40px',
  fontSize: '16px',
  padding: '0 12px',
  borderRadius: '5px',
  marginTop: '0.5rem',
  marginBottom: '0.5rem',
};

const mapContainerStyle = {
  width: '100%',
  height: '23vw',
  maxHeight: '25vw',
};
const defaultCenter = { lat: -34.6037, lng: -58.3816 }; // Buenos Aires
const googleApiKey = process.env.RAZZLE_RUNTIME_GOOGLE_API_KEY;

export default function AddressSearch({ markers = [], handleSetMarkers, limitMarkers = 5 }) {
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: googleApiKey,
    libraries: ['places'],
    language: 'es',
  });
  const [map, setMap] = useState(null);

  const onLoad = useCallback((map) => {
    setMap(map);
  }, []);

  const onUnmount = useCallback(() => {
    setMap(null);
  }, []);

  const autocompleteRef = useRef(null);

  const handlePlaceChanged = () => {
    const place = autocompleteRef?.current?.getPlace();
    if (!place?.geometry || !place?.geometry?.location) return;

    const newMarker = {
      id: place.place_id,
      position: {
        lat: place?.geometry?.location?.lat(),
        lng: place?.geometry?.location?.lng(),
      },
      label: place?.name,
      formatedAddres: place?.formatted_address,
      radiusInKm: 1,
    };

    handleSetMarkers(newMarker);
    const inputEl = document.querySelector('.map-autocomplete-on input');
    if (inputEl) inputEl.value = '';
    map?.panTo(newMarker.position);
  };

  return isLoaded ? (
    <>
      {limitMarkers > markers?.length && (
        <Autocomplete
          onLoad={(autocomplete) => {
            autocompleteRef.current = autocomplete;
          }}
          onPlaceChanged={handlePlaceChanged}
          className="map-autocomplete-on"
        >
          <Input
            type="text"
            placeholder={t('LOCATION_MAP_SEARCH_PALCEHOLDER')}
            style={inputStyle}
          />
        </Autocomplete>
      )}

      <GoogleMap
        mapContainerStyle={mapContainerStyle}
        center={markers?.[0]?.position || defaultCenter}
        zoom={15}
        onLoad={onLoad}
        onUnmount={onUnmount}
        options={{
          streetViewControl: false,
          fullscreenControl: false,
          cameraControl: false,
          mapTypeControl: false,
          styles: [
            {
              featureType: 'road',
              elementType: 'labels.icon',
              stylers: [{ visibility: 'off' }],
            },
            {
              featureType: 'transit',
              stylers: [{ visibility: 'off' }],
            },
          ],
        }}
      >
        {markers &&
          markers?.map((marker) => (
            <Fragment key={marker.id}>
              <Marker
                key={marker.id}
                position={marker.position}
                icon={{
                  url: marker?.icon || PointerMap,
                  scaledSize: new window.google.maps.Size(50, 60),
                }}
                label={{
                  text: marker?.label || '',
                  className: marker?.className || 'd-none',
                }}
              />
              <Circle
                center={marker.position}
                radius={marker.radiusInKm * 1000} // km to meters
                options={{
                  strokeColor: marker.color || '#007BFF',
                  strokeOpacity: 0.8,
                  strokeWeight: 2,
                  fillColor: marker.color || '#007BFF',
                  fillOpacity: 0.35,
                }}
              />
            </Fragment>
          ))}
      </GoogleMap>
    </>
  ) : (
    <></>
  );
}
